import { render, staticRenderFns } from "./MyOrdersProvider.vue?vue&type=template&id=05a75423&scoped=true"
import script from "./MyOrdersProvider.vue?vue&type=script&lang=js"
export * from "./MyOrdersProvider.vue?vue&type=script&lang=js"
import style0 from "./MyOrdersProvider.vue?vue&type=style&index=0&id=05a75423&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a75423",
  null
  
)

export default component.exports